import { useContext } from "react";
import { UserAccessContext } from "./UserAccessContext";

export function useAccess() {
    return useContext(UserAccessContext) || {};
}
